import { render } from "./equipment-service-dcc.vue?vue&type=template&id=6516447a&scoped=true"
import script from "./equipment-service-dcc.vue?vue&type=script&lang=js"
export * from "./equipment-service-dcc.vue?vue&type=script&lang=js"

import "./equipment-service-dcc.vue?vue&type=style&index=0&id=6516447a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6516447a"]])

export default __exports__